import React from 'react';
import { 
    FaCcVisa, FaCcMastercard, FaCcAmex, FaCcPaypal, FaCcStripe, FaCcApplePay, FaGooglePay,
    FaFacebook, FaInstagram, FaTwitter, FaTiktok, FaYoutube, FaLinkedin,
    FaDhl, FaUps, FaFedex,
    FaAmazon, FaGoogle, FaMicrosoft, FaSpotify, FaSlack,
    FaCcDiscover, FaCcJcb, FaCcDinersClub, FaBitcoin, FaEthereum,
    FaPinterest, FaReddit, FaWhatsapp, FaTelegram, FaDiscord, FaSnapchat, FaTwitch,
    FaUsps
} from 'react-icons/fa';
import { 
    SiNike, SiAdidas, SiSamsung, SiApple, SiTesla, SiFord, SiCocaCola,
    SiIntel, SiAmd, SiNvidia, SiSony, SiHp, SiDell, SiLenovo, SiAsus, SiAcer, SiIbm, 
    SiAdobe, SiShopify, SiWordpress, SiWix, SiSquarespace
} from 'react-icons/si';

const LOGO_MAP = {
    // Payment
    'visa': { icon: FaCcVisa, label: 'Visa', color: '#1A1F71' },
    'mastercard': { icon: FaCcMastercard, label: 'Mastercard', color: '#EB001B' },
    'amex': { icon: FaCcAmex, label: 'Amex', color: '#2E77BC' },
    'paypal': { icon: FaCcPaypal, label: 'PayPal', color: '#003087' },
    'stripe': { icon: FaCcStripe, label: 'Stripe', color: '#008CDD' },
    'apple_pay': { icon: FaCcApplePay, label: 'Apple Pay', color: '#000000' },
    'google_pay': { icon: FaGooglePay, label: 'Google Pay', color: '#5F6368' },
    'discover': { icon: FaCcDiscover, label: 'Discover', color: '#FF6000' },
    'jcb': { icon: FaCcJcb, label: 'JCB', color: '#1F355E' },
    'diners': { icon: FaCcDinersClub, label: 'Diners Club', color: '#004A97' },
    'bitcoin': { icon: FaBitcoin, label: 'Bitcoin', color: '#F7931A' },
    'ethereum': { icon: FaEthereum, label: 'Ethereum', color: '#3C3C3D' },
    
    // Social
    'facebook': { icon: FaFacebook, label: 'Facebook', color: '#1877F2' },
    'instagram': { icon: FaInstagram, label: 'Instagram', color: '#E4405F' },
    'twitter': { icon: FaTwitter, label: 'Twitter', color: '#1DA1F2' },
    'tiktok': { icon: FaTiktok, label: 'TikTok', color: '#000000' },
    'youtube': { icon: FaYoutube, label: 'YouTube', color: '#FF0000' },
    'linkedin': { icon: FaLinkedin, label: 'LinkedIn', color: '#0A66C2' },
    'pinterest': { icon: FaPinterest, label: 'Pinterest', color: '#BD081C' },
    'reddit': { icon: FaReddit, label: 'Reddit', color: '#FF4500' },
    'whatsapp': { icon: FaWhatsapp, label: 'WhatsApp', color: '#25D366' },
    'telegram': { icon: FaTelegram, label: 'Telegram', color: '#0088CC' },
    'discord': { icon: FaDiscord, label: 'Discord', color: '#5865F2' },
    'snapchat': { icon: FaSnapchat, label: 'Snapchat', color: '#FFFC00' },
    'twitch': { icon: FaTwitch, label: 'Twitch', color: '#9146FF' },

    // Shipping
    'dhl': { icon: FaDhl, label: 'DHL', color: '#D40511' },
    'ups': { icon: FaUps, label: 'UPS', color: '#FFB500' },
    'fedex': { icon: FaFedex, label: 'FedEx', color: '#4D148C' },
    'usps': { icon: FaUsps, label: 'USPS', color: '#333366' },

    // Tech / Brands
    'google': { icon: FaGoogle, label: 'Google', color: '#4285F4' },
    'microsoft': { icon: FaMicrosoft, label: 'Microsoft', color: '#F25022' },
    'amazon': { icon: FaAmazon, label: 'Amazon', color: '#FF9900' },
    'spotify': { icon: FaSpotify, label: 'Spotify', color: '#1DB954' },
    'slack': { icon: FaSlack, label: 'Slack', color: '#4A154B' },
    'apple': { icon: SiApple, label: 'Apple', color: '#000000' },
    'samsung': { icon: SiSamsung, label: 'Samsung', color: '#1428A0' },
    'tesla': { icon: SiTesla, label: 'Tesla', color: '#E82127' },
    'nike': { icon: SiNike, label: 'Nike', color: '#000000' },
    'adidas': { icon: SiAdidas, label: 'Adidas', color: '#000000' },
    'intel': { icon: SiIntel, label: 'Intel', color: '#0071C5' },
    'amd': { icon: SiAmd, label: 'AMD', color: '#ED1C24' },
    'nvidia': { icon: SiNvidia, label: 'Nvidia', color: '#76B900' },
    'sony': { icon: SiSony, label: 'Sony', color: '#000000' },
    'hp': { icon: SiHp, label: 'HP', color: '#0096D6' },
    'dell': { icon: SiDell, label: 'Dell', color: '#007DB8' },
    'lenovo': { icon: SiLenovo, label: 'Lenovo', color: '#E2231A' },
    'asus': { icon: SiAsus, label: 'Asus', color: '#00539B' },
    'acer': { icon: SiAcer, label: 'Acer', color: '#83B81A' },
    'ibm': { icon: SiIbm, label: 'IBM', color: '#052FAD' },
    'adobe': { icon: SiAdobe, label: 'Adobe', color: '#FF0000' },
    'shopify': { icon: SiShopify, label: 'Shopify', color: '#96BF48' },
    'wordpress': { icon: SiWordpress, label: 'WordPress', color: '#21759B' },
    'wix': { icon: SiWix, label: 'Wix', color: '#0C6EFC' },
    'squarespace': { icon: SiSquarespace, label: 'Squarespace', color: '#000000' }
};

const LogoCloud = ({ settings }) => {
    const {
        title = "Trusted By",
        logos = ['visa', 'mastercard', 'paypal', 'stripe'], // Array of keys
        grayscale = true,
        opacity = 0.6,
        size = "medium", // small, medium, large
        gap = "medium" // small, medium, large
    } = settings;

    const sizeClasses = {
        small: "text-2xl md:text-3xl",
        medium: "text-4xl md:text-5xl",
        large: "text-5xl md:text-6xl"
    }[size] || "text-4xl md:text-5xl";

    const gapClasses = {
        small: "gap-4 md:gap-6",
        medium: "gap-8 md:gap-12",
        large: "gap-12 md:gap-16"
    }[gap] || "gap-8 md:gap-12";

    return (
        <div className="py-12 px-4 bg-[var(--store-bg)] text-[var(--store-text)]">
            {title && (
                <h2 className="text-2xl font-bold text-center mb-8">{title}</h2>
            )}
            
            <div className={`flex flex-wrap justify-center items-center ${gapClasses} max-w-6xl mx-auto`}>
                {logos.map((logoKey, index) => {
                    const logoDef = LOGO_MAP[logoKey];
                    if (!logoDef) return null;
                    
                    const Icon = logoDef.icon;
                    
                    return (
                        <div 
                            key={index} 
                            className={`transition-all duration-300`}
                            style={{ opacity: opacity }}
                            title={logoDef.label}
                        >
                            <Icon className={`${sizeClasses} text-[var(--store-muted)]`} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LogoCloud;
export { LOGO_MAP };
